import { colorisConfig } from "./coloris_config"

// Coloris creates a single shared #clr-picker element once and appends it wherever
// `config.parent` points (body by default). If that ancestor is later removed from
// the document (a modal closing, a Turbo Frame swap, ...) the picker gets detached
// along with it, but Coloris keeps referencing the same node internally, so every
// later Coloris(config) call throws trying to read its now-detached children.
//
// Checking `picker.isConnected` isn't enough to catch this: Coloris only moves the
// picker into the new `parent` as part of processing that config call, and on a
// Turbo Frame swap (e.g. the settings modal reloading) the *old* parent can still
// be connected to the document at the exact moment the new controller instance
// connects — isConnected reads true, nothing gets reattached, and then the old
// parent (picker still inside it) is removed a moment later with no further code
// path left to fix it. So instead of waiting for the picker to go stale, always
// move it into the current intended parent proactively. A detached picker can no
// longer be found via getElementById, so its reference is cached the first time
// it's seen, while it's still attached.
let cachedPicker = null

function reattachPickerIfDetached(parentSelector) {
  const picker = cachedPicker || document.getElementById('clr-picker')

  if (!picker) return

  cachedPicker = picker

  const parent = (parentSelector instanceof HTMLElement ? parentSelector : document.querySelector(parentSelector)) || document.body

  if (!parent.contains(picker)) {
    parent.appendChild(picker)
  }
}

export class ColorisManager {
  constructor(element, config = {}) {
    this.element = element
    this.config = {
      ...colorisConfig,
      ...config
    }
    this.init()
  }

  init() {
    const colorInputs = this.element.querySelectorAll('.coloris-input')

    if (colorInputs.length > 0) {
      reattachPickerIfDetached(this.config.parent)
      Coloris(this.config)
    }

    this.setupClearButtons()
  }

  setupClearButtons() {
    this.element.querySelectorAll('.clear-color-btn').forEach(clearBtn => {
      clearBtn.addEventListener('click', () => {
        const colorType = clearBtn.getAttribute('data-color-type')
        const textInput = this.element.querySelector(`.coloris-input[data-color-type="${colorType}"]`)

        if (textInput) {
          textInput.value = ''
          textInput.dispatchEvent(new Event('input', { bubbles: true }))
        }
      })
    })
  }
}
